import React from "react";

import styles from "../assets/styles/FinlandSignIn.module.scss";

class FinlandSignIn extends React.Component {
	constructor(props) {
		super(props);

		this.setTextInputRef = element => {
			this.textInput = element;
		};

		this.state = { showError: false };
	}

	onKeyDown = e => {
		if (e.key === "Enter" && this.textInput.value.length > 0) {
			this.triggerErrorMessage();
		}
		if (e.key !== "Enter") {
			this.clearErrorMessage();
		}
	};

	triggerErrorMessage = () => {
		this.setState({ showError: true });
		this.textInput.value = null;
	};

	clearErrorMessage = () => {
		this.setState({ showError: false });
	};

	render() {
		let className = styles.error;
		if (this.state.showError) className += ` ${styles.shown}`;
		return (
			<div className={styles.root}>
				<div className={styles.label}>Sign in</div>
				<input
					type="text"
					className={styles.input}
					onKeyDown={this.onKeyDown}
					onBlur={this.clearErrorMessage}
					ref={this.setTextInputRef}
				/>
				<div className={className}>
					Sorry, we didn't find anyone by that ID.
				</div>
			</div>
		);
	}
}

export default FinlandSignIn;
